<template>
  <v-datetime-picker
    locale="zh-cn"
    clear-text='清空'
    ok-text='确定'
    :text-field-props='filedProps'
    :date-picker-props="dateProps"
    :time-picker-props='timeProps'
    time-format="HH:mm:ss"
    :label="label"
    v-model="datetime"
    @input='inputValue'
    v-bind="$attrs"
    >
      <template slot="dateIcon">
        <v-icon>mdi-calendar-range</v-icon>
      </template>
      <template slot="timeIcon">
        <v-icon>mdi-clock-outline</v-icon>
      </template>
      <!-- <template slot="actions" slot-scope="{ parent }">
        <v-btn color="error lighten-1" text @click.native="parent.clearHandler">清空</v-btn>
        <v-btn color="success darken-1" text @click="parent.okHandler">确定</v-btn>
      </template> -->
    </v-datetime-picker>
</template>

<script>
  export default {
    name: 'MaterialTimePicker',
    props: {
      value: {
        type: [String, Date],
        default: ''
      },
      label: {
        type: String,
        default: '时间选择'
      },
      filedProps: {
        type: Object,
        default: () => ({
          outlined: true
        })
      },
      dateProps: {
        type: Object,
        default: () => ({
          locale: 'zh-cn'
        })
      },
      timeProps: {
        type: Object,
        default: () => ({
          locale: 'zh-cn',
          format: '24hr'
        })
      },
      rules: {
        type: Array
      }
    },
    data () {
      return {
        datetime: '',
        parent: null
      }
    },
    computed: {
    },
    watch: {
    },
    methods: {
      inputValue (val) {
        console.log(val)
        this.$emit('input', val)
      }
    }
  }
</script>
